/**
 * customField Group
 * @param fb : FormBuilder
 */
export function customFieldGroup (fb: any) {
    fb.array([
        this.group({
            usage: [''],
            name: [''],
            delimiter: [''],
            text: ['']
        })
    ])
}
